import React from 'react';
import classNames from 'classnames';
import './RadioButtons.scss';

interface RadioButtonProps {
  name: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  label: string;
  disabled?: boolean;
  className?: string;
}

const RadioButton = ({
  name,
  value,
  checked,
  onChange,
  label,
  disabled = false,
  className,
}: RadioButtonProps) => {
  return (
    <div className={classNames('radio-button', className)}>
      <label className="radio-button__label">
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={() => onChange(value)}
          disabled={disabled}
          className="radio-button__input"
        />
        <span className="radio-button__custom"></span>
        <span className="radio-button__text">{label}</span>
      </label>
    </div>
  );
};

export default RadioButton;
